<template>
  <v-content>
      <v-layout fill-height justify-center align-center>
        <v-card class="mobile-style">
          <v-card-title class="secondary mobile-top">
            <div class="mobile-utils-container">
                <div class="camera"></div>
            </div>
          </v-card-title>
          <v-card-text class="mobile-content secondary">
            <div v-show="showOffContainer" class="off-view-container">
              <div class="img-bg">
                <v-btn @click="showCashierMethod" small rounded class="secondary img-bg-btn">
                  Select a payment method
                </v-btn>
              </div>
            </div>
            <div style="width:100%;position:relative" v-if="showCashier">
              <div class="cashier-header">
                <div @click="closeCashier" style="cursor: pointer" class="body-2 white--text">
                  Cancel
                </div>
                <div text class="bold-text subheading">
                    Payment.
                </div>
                <div style="visibility: hidden">Payment</div>
              </div>
                <Cashier
                  :key="showOffContainer"
                  :customCssProp="customCssProp"
                  :customBorderProp="customBorderProp"
                  :customConfigs="customConfigs"
                  :customFunction="doneLoading" />
                <div v-show="false && cashierHasLoaded" class="fill-out-bottom" :style="`color:${getBg};background:${getBg}`">
                  ---
                </div>
            </div>
          </v-card-text>
        </v-card>
      </v-layout>
  </v-content>
</template>

<script>
import Cashier from '@/components/Cashier'

export default {
  components: {
    Cashier
  },
  data: () => ({
    cashierHasLoaded: false,
    showOffContainer: true,
    showCashier: false,
    customConfigs: {
      containerWidth: '363px',
      containerHeight: '670px'
    }
  }),
  computed: {
    getBg () {
      const urlConfigsHash = JSON.parse(decodeURIComponent(window.location.hash).replace('#__PiqCashierConfigs__=', ''))
      return urlConfigsHash.theme.cashierbackground.color
    },
    customBorderProp () {
      return `
      border-bottom-left-radius: 19px!important;
      border-bottom-right-radius: 19px!important;
      overflow: hidden;
      `
    },
    customCssProp () {
      return `
      #app-container {
        border-radius: 0px!important;
      }
      .cashier-header {
        display: flex;
        justify-content: center;
      }
      .cashier-header-logo {
        background-position: 45%!important;
      }
      `
    }
  },
  methods: {
    doneLoading () {
      setTimeout(() => { this.cashierHasLoaded = true }, 100)
    },
    closeCashier () {
      this.cashierHasLoaded = false
      this.showOffContainer = true
      this.showCashier = false
    },
    showCashierMethod () {
      this.showOffContainer = false
      this.showCashier = true
    }
  }
}
</script>

<style lang="scss" scoped>
.fill-out-bottom {
 position: absolute;
 top:695px;
 width: 100%;
}
  .mobile-style {
    border: 6px double #000000!important;
    border-radius: 25px!important;
    min-height: 760px;
    min-width: 375px;
    max-height: 760px;
    max-width: 375px;
    overflow: hidden;
  }
  .mobile-top {
    position: relative;
    margin: auto;
    border-top-left-radius: 0!important;
    border-top-right-radius: 0!important;
    border-bottom-left-radius: 22px!important;
    border-bottom-right-radius: 22px!important;
    width: 250px;
    height: 4px;
    z-index: 100;
  }
  .mobile-utils-container {
    margin: auto;
    border: 1px solid #4c4a4a;
    width: 100px;
    margin-top: -4px;
  }
  .camera {
    position: absolute;
    padding: 4px;
    border-radius: 100%;
    background: #615f5f;
    top: 10px;
    right: 40px;
  }
  .mobile-content {
    display: flex;
    justify-content: center;
    padding: 0;
  }
  .off-view-container {
    position: relative;
  }
  .img-bg {
    margin-top: -33px;
    background-image: url('../assets/maps-bg.png');
    background-color: #cccccc;
    height: 750px;
    width: 400px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
  .img-bg-btn {
    text-align: center;
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
  }
  .cashier-header {
    display: flex;
    justify-content: space-between;
    margin-top: -32px;
    background: #333333;
    color: #ffffff;
    padding-top: 45px;
    padding-bottom: 10px;
    padding-left: 14px;
    width: 100%;
  }
</style>
